import _classCallCheck from '@babel/runtime/helpers/classCallCheck'
import _createClass from '@babel/runtime/helpers/createClass'

const LoadingCounterInstance = (function LoadingCounterBuilder() {
  function LoadingCounter() {
    _classCallCheck(this, LoadingCounter)

    this.count = 0
  }

  _createClass(LoadingCounter, [{
    key: 'add',
    value: function add() {
      this.count += 1
    },
  }, {
    key: 'dec',
    value: function dec() {
      this.count -= 1
    },
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      return this.count <= 0
    },
  }, {
    key: 'clear',
    value: function clear() {
      this.count = 0
    },
  }])

  return LoadingCounter
}())

export default LoadingCounterInstance
